module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ddc9fae77e4b0dc8e1b094f48d1c6e18.png";